var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProgressActiveIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12c0-4.4183-3.5817-8-8-8s-8 3.5817-8 8 3.5817 8 8 8 8-3.5817 8-8m-12.5715-.0001c0-2.5247 2.0467-4.5714 4.5714-4.5714s4.5714 2.0467 4.5714 4.5714-2.0467 4.5714-4.5714 4.5714-4.5714-2.0467-4.5714-4.5714M12 14.6667c1.4727 0 2.6666-1.1939 2.6666-2.6667 0-1.4727-1.1939-2.6667-2.6666-2.6667-1.4728 0-2.6667 1.194-2.6667 2.6667s1.194 2.6667 2.6667 2.6667",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProgressActiveIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/progress-active-icon.b295d225aa11e0351c3aca702eec472a.svg";